<template lang="html">
  <div class="uk-container" style="height: calc(100% - 55px)">

    <div class="uk-flex uk-flex-left margin-top-responsive">
      <div id="logo" class="uk-padding-small">
        <img :src="config.logo_url" alt="Logo" />
      </div>
    </div>

    <div v-if="loginShow === false" class="uk-flex uk-flex-wrap uk-flex-center padding-responsive">
      <div class="uk-width-1-2@s">
        <div class="uk-card uk-card-default uk-card-body">
          <h3 class="uk-card-title">
            Ustawienie nowego hasła
          </h3>
          <div v-if="error_box" uk-alert class="uk-alert-danger">
            <h3>Wystąpił błąd</h3>
            <p>Podany numer pacjenta lub hasło jest nieprawidłowe.</p>
          </div>
          <div v-if="error_box_mismatch" uk-alert class="uk-alert-danger">
            <h3>Wystąpił błąd</h3>
            <p>Podane hasła nie są takie same.</p>
          </div>
          <div v-if="error_box_characters" uk-alert class="uk-alert-danger">
            <h3>Wystąpił błąd</h3>
            <p>Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.</p>
          </div>
          <div v-if="error_box_empty" uk-alert class="uk-alert-danger">
            <h3>Wystąpił błąd</h3>
            <p>Proszę wprowadzić ID pacjenta oraz hasło.</p>
          </div>
          <div v-if="error_terms" uk-alert class="uk-alert-danger">
            <p>Akceptacja informacji o przetwarzaniu jest wymagana.</p>
          </div>

          <fieldset class="uk-fieldset">
            <!-- pass change -->
            <div class="uk-margin">
              <input class="uk-input" type="password" placeholder="Nowe hasło" v-model="credentials.passNew">
            </div>
            <div class="uk-margin">
              <input class="uk-input" type="password" placeholder="Powtórz nowe hasło" v-model="credentials.passNew_2">
            </div>
            <div class="uk-margin" id="terms">
              <label>
                <input class="uk-checkbox" type="checkbox" v-model="credentials.terms" />
                Zapoznałem się z <a uk-toggle="target: #terms-modal" href="#">informacją o administratorze i przetwarzaniu danych</a>
              </label>
            </div>
            <div class="uk-flex uk-flex-right">
              <button v-if="Object.getOwnPropertyNames($route.params).length === 0" @click="NewPass" class="uk-button uk-button-secondary uk-margin-small-left" id="newpassbtn">Potwierdź zmiane hasła</button>
              <button v-if="Object.getOwnPropertyNames($route.params).length !== 0" @click="HashNewPass" class="uk-button uk-button-secondary uk-margin-small-left" id="hashnewpassbtn">Zatwierdź</button>
            </div>
          </fieldset>

        </div>
      </div>
    </div>

    <div v-if="loginShow === true" class="uk-card uk-card-default uk-card-body padding-responsive">
      <div class="uk-flex uk-flex-wrap uk-flex-center">

        <div  class="uk-width-1 uk-width-1-2@m">
          <div class="uk-card uk-card-default uk-card-body">

            <h3 class="uk-card-title">
              Logowanie do konta Pacjenta?
            </h3>
            <h4 v-if="Object.getOwnPropertyNames($route.params).length !== 0">Id Pacjenta: {{ $route.params.id }}</h4>

            <div v-if="error_box" uk-alert class="uk-alert-danger">
              <h3>Wystąpił błąd</h3>
              <p>Podany numer pacjenta lub hasło jest nieprawidłowe.</p>
            </div>
            <div v-if="error_box_mismatch" uk-alert class="uk-alert-danger">
              <h3>Wystąpił błąd</h3>
              <p>Podane hasła nie są takie same.</p>
            </div>
            <div v-if="error_box_characters" uk-alert class="uk-alert-danger">
              <h3>Wystąpił błąd</h3>
              <p>Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.</p>
            </div>
            <div v-if="error_box_empty" uk-alert class="uk-alert-danger">
              <h3>Wystąpił błąd</h3>
              <p>Proszę wprowadzić ID pacjenta oraz hasło.</p>
            </div>
            <div v-if="error_terms" uk-alert class="uk-alert-danger">
              <p>Akceptacja informacji o przetwarzaniu jest wymagana.</p>
            </div>

            <fieldset class="uk-fieldset">
              <div class="uk-margin">
                <input class="uk-input" type="text" placeholder="ID pacjenta" v-model="credentials.ID" id="idinp">
              </div>
              <div class="uk-margin">
                <input class="uk-input" type="password" placeholder="Hasło" v-model="credentials.pass" id="passinp">
              </div>
              
              <div class="uk-margin-top">
                <div class="uk-flex uk-flex-between">
                  <button v-if="logging_in === false" @click="login" class="uk-button uk-button-secondary" id="loginbtn">Zaloguj</button>
                  <button v-if="logging_in !== false" id="loginbtn-disabled" class="uk-button uk-button-secondary" disabled>
                    <i class="fas fa-spinner"></i> Trwa uwierzytelnianie
                  </button>
                  <!-- pass change -->
                  <button type="button" class="uk-button uk-button-link uk-margin-left" uk-toggle="target: #rememberButtons">Problem z logowaniem</button>
                </div>

                <div id="rememberButtons" hidden class="uk-flex uk-flex-right uk-margin-top">
                  <button uk-toggle="target: #id-patient-reminder-modal" class="uk-button uk-button-default uk-button-small uk-margin-small-left" id="rememberIDBtn">Przypomnij ID pacjenta</button>
                  <button uk-toggle="target: #remember-modal" class="uk-button uk-button-default uk-button-small uk-margin-small-left" id="rememberbtn">Przypomnij hasło</button>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <div class="uk-hidden@m uk-margin-top">
          <span class="uk-badge" style="width: 40px; height: 40px; font-size: medium;">lub</span>
        </div>

        <div class="uk-width-1 uk-width-1-2@m">
          <div class="uk-card uk-card-body">
            <h3 class="uk-card-title">
              Pierwsze logowanie?
            </h3>
            <p>Jeżeli jesteś naszym Pacjentem i podczas pobytu w placówce otrzymałeś sms z identyfikatorem aktywuj konto.</p>
            <div class="uk-flex uk-flex-right">
              <button uk-toggle="target: #firstlogin-modal" class="uk-button uk-button-default uk-button-small uk-margin-small-left" id="firstLoginBtn">Aktywuj konto</button>
            </div>
          </div>
        </div>

        <div class="uk-visible@m uk-position-absolute" style="margin-top: 8em;">
          <span class="uk-badge" style="width: 40px; height: 40px; font-size: medium;">lub</span>
        </div>
      </div>
    </div>

    <div id="terms-modal" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Informacja dla pacjenta</h2>
        <div class="uk-margin" v-html="config.clinic_info.terms">
        </div>
        <div class="uk-flex uk-flex-right">
          <button class="uk-button uk-button-default uk-modal-close uk-margin-small-left" type="button">Zamknij</button>
        </div>
        </p>
      </div>
    </div>

    <div id="remember-modal" uk-modal="bg-close: false">
      <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Przypomnienie hasła</h2>
        <div class="uk-margin">
          <input class="uk-input" type="text" placeholder="ID pacjenta" v-model="remember.ID" id="rememberidinp">
        </div>
        <div class="uk-margin">
          <input class="uk-input" type="email" placeholder="Email podany przy rejestracji" v-model="remember.email" id="rememberemailinp" v-on:keyup.13="rememberAction">
        </div>
        <div class="uk-margin">
          <p>Jeżeli nie podałeś adresu email podczas logowania, przypomnienie hasła może się odbyć tylko w klinice.</p>
        </div>
        <div class="uk-flex uk-flex-right">
          <button class="uk-button uk-button-default uk-modal-close uk-margin-small-left" type="button">Anuluj</button>
          <button @click="rememberAction" class="uk-button uk-button-secondary uk-modal-close uk-margin-small-left" type="button">Przypomnij</button>
        </div>
      </div>
    </div>

    <div id="id-patient-reminder-modal" uk-modal="bg-close: false">
      <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Przypomnienie ID pacjenta</h2>
        <div class="uk-margin">
          <input v-mask="'999-999-999'" class="uk-input" type="tel" placeholder="Numer telefonu podany przy rejestracji" v-model="remember.phoneNumber">
        </div>
        <div class="uk-margin">
          <input v-mask="'99999999999'" class="uk-input" type="tel" placeholder="Numer PESEL" v-model="remember.pesel">
        </div>
        <div class="uk-flex uk-flex-right">
          <button class="uk-button uk-button-default uk-modal-close uk-margin-small-left" type="button">Anuluj</button>
          <button @click="rememberActionID" class="uk-button uk-button-secondary uk-modal-close uk-margin-small-left" type="button">Przypomnij</button>
        </div>
      </div>
    </div>

    <div id="email-patient-reminder-modal" uk-modal="bg-close: false">
      <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Brak adresu email</h2>
        <div id="error_empty_email" uk-alert class="uk-alert-danger" style="display: none;">
          <h3>Wystąpił błąd</h3>
          <p>Wprowadź poprawny adres email</p>
        </div>
        <p>
          Adres email będzie używany w celu późniejszego przypomnienia hasła do konta. Brak podania adresu email będzie wiązał się z konicznością przypomnienia hasła w klinice.
        </p>
        <div class="uk-margin">
          <input class="uk-input" type="email" placeholder="Twój aktualny email" v-model="remember.email">
        </div>

        <div class="uk-flex uk-flex-right">
          <button class="uk-button uk-button-default uk-modal-close uk-margin-small-left" type="button">Anuluj</button>
          <button @click="setEmail" class="uk-button uk-button-secondary uk-margin-small-left" type="button">Zapisz</button>
        </div>
      </div>
    </div>

    <div id="firstlogin-modal" uk-modal="bg-close: false">
      <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Pierwsze logowanie</h2>
        <div class="uk-margin">
          <input class="uk-input" type="tel" placeholder="ID pacjenta" v-model="credentials.ID">
        </div>
        <div class="uk-flex uk-flex-right">
          <button class="uk-button uk-button-default uk-modal-close uk-margin-small-left" type="button">Anuluj</button>
          <button @click="firstLogin" class="uk-button uk-button-secondary uk-modal-close uk-margin-small-left" type="button">Wyślij SMS z hasłem tymczasowym</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from 'uikit'
import $ from 'jquery'
import Vue from 'vue'
const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)
export default {
  name: 'login',
  data () {
    return {
      logging_in: false,
      credentials: {
        ID: '',
        pass: '',
        terms: false,
        passNew_2: '',
        passNew: ''
      },
      remember: {
        ID: '',
        email: '',
        phoneNumber: '',
        pesel: ''
      },
      error: '',
      contactMail: '',
      contactFromMail: '',
      error_terms: false,
      error_box: false,
      error_box_mismatch: false,
      error_box_characters: false,
      error_box_empty: false,
      loginShow: true
    }
  },
  computed: {
    config () {
      return this.$parent.config
    }
  },
  mounted: function () {
    if (this.$cookie.get('aut')) {
      var token = this.$cookie.get('aut')
      var refreshTokenMetod = {'input': {'status': '', 'data': {'TOKEN': token, 'reservation_id': null}}}
      this.$http.post('/api.php?url=refreshToken', refreshTokenMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
        this.$cookie.set('aut', token, { expires: '20m' })
        this.$router.replace({ path: '//dashboard' })
      }).catch((errors) => {
        JSON.stringify(errors)
        this.$cookie.delete('aut')
      })
    }
    $('#passinp').keyup(function (event) {
      if (event.keyCode === 13) {
        $('#loginbtn').click()
      }
    })
    if (this.$route.params.id !== undefined) {
      // Ustawienie hasła
      this.loginShow = false
      this.credentials.ID = this.$route.params.id
      $('#newpassbtn').hide()
      $('#hashnewpassbtn').show()
    }
    this.$http.get('/config.php').then((response) => {
      var resp = response.data
      this.contactMail = resp.emailZzalacznikiemAdres
      this.contactFromMail = resp.emailZzalacznikiemFrom
    }).catch((errors) => {
      JSON.stringify(errors)
    })
    const vm = this
    let logoConfInterval = setInterval(() => {
      if (vm.config.logo_width !== undefined) {
        clearInterval(logoConfInterval)
        $('#logo').css('width', vm.config.logo_width)
      }
    }, 100)
  },
  methods: {
    login (ID, pass) {
      this.logging_in = true
      this.error_box = false
      this.error_box_characters = false
      this.error_box_mismatch = false
      this.error_box_empty = false
      if (this.credentials.ID === '' || this.credentials.pass === '') {
        this.error_box_empty = true
        this.logging_in = false
        return false
      }
      var credentials = {
        input: {
          status: '',
          data: {
            ID: this.credentials.ID,
            pass: this.credentials.pass
          }
        }
      }
      // TOOD: XML
      this.$http.post('/api.php?url=login', credentials, {headers: {'Content-Type': 'application/json'}}).then((response) => {
        var odp = response.data
        var token = odp.d.data.TOKEN
        var cdata = { email: odp.d.data.email, name: odp.d.data.name, lastname: odp.d.data.lastname, id: this.credentials.ID }
        var firstLogin = odp.d.data.first
        // add client data
        this.$cookie.set('cdata', JSON.stringify(cdata), { expires: '1D' })
        if (firstLogin === false) {
          // kolejne logowanie
          this.$cookie.set('aut', token, { expires: '20m' })
          localStorage.setItem('unison_id', response.data.d.data.IDPacjent)
          if (cdata.email === '') {
            var modal = UIkit.modal('#email-patient-reminder-modal')
            modal.show()
          }
        } else {
          // pierwsze logowanie - wymagana zmiana hasla
          UIkit.modal.alert('Logujesz się pierwszy raz. Prosimy o zmiane hasła. Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.')
          this.loginShow = false
        }
        if (this.$cookie.get('aut')) {
          this.$router.replace({ path: '//dashboard' })
        }
        this.logging_in = false
      }).catch((errors) => {
        if (errors.status === 504 || errors.status === 500) {
          UIkit.modal.alert('Wystąpił problem z logowaniem, prosimy o kontakt z kliniką jeżeli problem będzie się powtarzał.')
        } else {
          this.error_box = true
        }
        this.logging_in = false
      })
    },
    NewPass () {
      this.error_box = false
      this.error_box_characters = false
      this.error_box_mismatch = false
      this.error_terms = false
      if (this.credentials.passNew) {
        var PID = this.credentials.ID
        var Ppass = this.credentials.pass
        var PpassNew = this.credentials.passNew
        var changePasswordInput = {'input': {'status': '', 'data': {'ID': PID, 'pass': Ppass, 'new_pass': PpassNew}}}
        var reg = /^(?=.*\d)(?=.*[!@#$%^&*()+-={}|:<>?';.])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
        if (this.credentials.passNew !== this.credentials.passNew_2) {
          this.error_box_mismatch = true
        } else if (!this.credentials.terms) {
          this.error_terms = true
        } else if (reg.test(PpassNew)) {
          // new pass validate ok
          // TOOD: XML
          this.$http.post('/api.php?url=changePassword', changePasswordInput, {headers: {'Content-Type': 'application/json'}}).then((response) => {
            // var odp = response.data
            // var token = odp.d.data.TOKEN
            // this.$cookie.set('aut', token, { expires: '20m' })
            // if (this.$cookie.get('aut')) {
            UIkit.modal.alert('Hasło zostało zmienione poprawnie. Zaraz zostaniesz przekierowany do swojego konta.')
            this.credentials.pass = PpassNew
            this.login()
              // this.$router.push('main')
            // }
          }).catch((errors) => {
            JSON.stringify(errors)
            UIkit.modal.alert('Wystąpił problem przy zmianie hasła, prosimy o kontakt z kliniką jeżeli problem będzie się powtarzał.')
          })
        } else {
          this.error_box_characters = true
          // UIkit.modal.alert('Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.')
        }
      } else {
        this.error_box_characters = true
        // UIkit.modal.alert('Wpisz nowe hasło')
      }
    },
    HashNewPass () {
      this.error_box = false
      this.error_box_characters = false
      this.error_box_mismatch = false
      this.error_terms = false
      if (this.credentials.passNew) {
        var PpassNew = this.credentials.passNew
        var hashLoginRequest = {
          'request': {
            'Id': this.$route.params.id,
            'NewPass': this.credentials.passNew,
            'Hash': this.$route.params.hash,
            'Terms': this.credentials.terms,
            'TermsContent': this.config.clinic_info.terms
          }
        }
        var reg = /^(?=.*\d)(?=.*[!@#$%^&*()+-={}|:<>?';.])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
        if (this.credentials.passNew !== this.credentials.passNew_2) {
          this.error_box_mismatch = true
        } else if (!this.credentials.terms) {
          this.error_terms = true
        } else if (reg.test(PpassNew)) {
          // new pass validate ok
          this.$http.post('/api.php?url=HashLogin', hashLoginRequest, { headers: { 'Content-Type': 'application/json' } }).then((response) => {
            var r = response.data.d
            if (r.IsSuccess) {
              UIkit.modal.alert('Hasło zostało ustawione poprawnie. Zaraz zostaniesz przekierowany do swojego konta.')
              this.credentials.pass = this.credentials.passNew
              console.log(this)
              this.login()
            } else {
              UIkit.modal.alert('Wystąpił problem przy ustawianiu hasła, prosimy o kontakt z kliniką jeżeli problem będzie się powtarzał.')
            }
            // var token = odp.d.data.TOKEN
            // this.$cookie.set('aut', token, { expires: '20m' })
            // if (this.$cookie.get('aut')) {
          }).catch((err) => {
            if (err.status === 404) {
              UIkit.modal.alert('Nie znaleziono pacjenta, lub wskazany link wygasł.')
            } else {
              UIkit.modal.alert('Wystąpił problem przy ustawianiu hasła, prosimy o kontakt z kliniką jeżeli problem będzie się powtarzał.')
            }
          })
        } else {
          this.error_box_characters = true
        }
      } else {
        this.error_box_characters = true
      }
    },
    setEmail () {
      const vm = this
      var regex = /^.+@.+$/
      if (vm.remember.email === '' || !regex.test(vm.remember.email)) {
        $('#email-patient-reminder-modal #error_empty_email').show()
        return
      } else {
        $('#email-patient-reminder-modal #error_empty_email').hide()
        var token = this.$cookie.get('aut')
        const data = { 'request': { 'Id': vm.credentials.ID, 'Token': token, 'Email': vm.remember.email } }
        vm.$http.post('/api.php?url=SetEmail', data, { headers: { 'Content-Type': 'application/json' } }).then(response => {
          var cdata = $.parseJSON(this.$cookie.get('cdata'))
          cdata.email = vm.remember.email
          this.$cookie.set('cdata', JSON.stringify(cdata), { expires: '1D' })
          UIkit.modal.alert('Dziękujemy.')
        }).catch(err => {
          if (err.status === 400) {
            UIkit.modal.alert('Nieprawidłowe dane.')
          } else {
            UIkit.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką')
          }
        })
      }
    },
    firstLogin () {
      const vm = this
      vm.error_box = false
      vm.error_box_characters = false
      vm.error_box_mismatch = false
      const data = { 'request': { 'Id': vm.credentials.ID } }
      vm.$http.post('/api.php?url=FirstLogin', data, { headers: { 'Content-Type': 'application/json' } }).then(response => {
        UIkit.modal.alert('Dziękujemy. Na Twój numer telefonu zostało wysłane tymczasowe hasło.')
        vm.credentials.pass = ''
        vm.remember.phoneNumber = ''
      }).catch(err => {
        vm.credentials.ID = ''
        if (err.status === 400) {
          UIkit.modal.alert('Nieprawidłowe dane.')
        } else if (err.status === 403) {
          UIkit.modal.alert('Hasło zostało już wcześniej zmienione')
        } else {
          UIkit.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką')
        }
      })
    },
    rememberActionID () {
      const vm = this
      vm.error_box = false
      vm.error_box_characters = false
      vm.error_box_mismatch = false
      const data = {'request': { 'phone': vm.remember.phoneNumber, 'pesel': vm.remember.pesel }}
      vm.$http.post('/api.php?url=RemindId', data, {headers: {'Content-Type': 'application/json'}}).then(response => {
        UIkit.modal.alert('Dziękujemy. Na Twój numer telefonu zostało wysłane twoje ID pacjenta.')
        vm.credentials.pass = ''
        vm.credentials.ID = ''
        vm.remember.phoneNumber = ''
        vm.remember.pesel = ''
      }).catch(err => {
        if (err.status === 400) {
          UIkit.modal.alert('Błędnie wprowadzony numer telefonu lub PESEL.')
        } else if (err.status === 404) {
          UIkit.modal.alert('Błędnie wprowadzony numer telefonu lub PESEL.')
        } else {
          UIkit.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką')
        }
        vm.remember.phoneNumber = ''
        vm.remember.pesel = ''
      })
    },
    rememberAction () {
      const vm = this
      vm.error_box = false
      vm.error_box_characters = false
      vm.error_box_mismatch = false
      var tryResetMetod = {'input': {'ID': vm.remember.ID, 'mail': vm.remember.email}}
      vm.$http.post('/api.php?url=tryReset', tryResetMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
        UIkit.modal.alert('Niedługo dostaniesz hasło tymczasowe w wiadomości Email.')
        vm.credentials.pass = ''
        $('#passinp').attr('placeholder', 'Wpisz hasło otrzymane w wiadomości Email')
      }).catch((errors) => {
        // alert(JSON.stringify(errors))
        if (errors.status === 404) {
          UIkit.modal.alert('Zły login lub email')
        } else {
          UIkit.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką')
        }
      })
    }
  }
}
</script>


<style lang="sass" scoped>

  $small-break: 960px

  .uk-button-secondary
    background: #21555d;

  .uk-button-small
    line-height: 1.5;
    padding: 5px 15px;

  .margin-top-responsive
    margin-top: 10em;
    @media screen and (max-width: $small-break)
      margin-top: 0px;

  .padding-responsive
    @media screen and (max-width: 640px)
      padding: 15px;

  .error
    display: none
    background: rgba(232, 23, 23, 0.9)
    padding: 10px

    .message
      font-weight: 400 !important

  #login *, #register *
    font-weight: 300

  #login
    @media screen and (max-width: $small-break)
      margin-bottom: 20px

  #login
    border: 1px solid rgba(#000, .1)
    border-radius: 5px
    padding-top: 30px

    .uk-fieldset
      margin-bottom: 10px

  #logo
    max-width: 200px

  i.fas
    animation: fa-spin 2s infinite linear !important

  // header
  //   position: absolute
  //   top: 20px
  //   height: 110px
  //   width: 300px

  //   @media screen and (max-width: $small-break)
  //     position: relative

</style>



// WEBPACK FOOTER //
// Login.vue?2cf8b416